export default "__VITE_ASSET__BvHlLkUM__"